var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmTeams(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.666,
    height: 13.956,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6580",
    fill: "#5200f1",
    stroke: "#fff",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6586",
    d: "M5.637 6.978a3.426 3.426 0 113.426-3.426 3.426 3.426 0 01-3.426 3.426zm0-1.49A1.937 1.937 0 103.7 3.551a1.937 1.937 0 001.937 1.937zm5.512 7.6a.745.745 0 01-1.49 0 4.022 4.022 0 10-8.045 0 .745.745 0 01-1.49 0 5.512 5.512 0 0111.024 0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6587",
    d: "M13.029 6.978a3.426 3.426 0 113.427-3.426 3.426 3.426 0 01-3.427 3.426zm0-1.49a1.937 1.937 0 10-1.936-1.937 1.937 1.937 0 001.936 1.937zm5.512 7.6a.745.745 0 01-1.49 0 4.022 4.022 0 10-8.045 0 .745.745 0 01-1.49 0 5.512 5.512 0 0111.024 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmTeams);
export default __webpack_public_path__ + "static/media/am-teams.64ea9885e18942918d7e67aa6c4c0790.svg";
export { ForwardRef as ReactComponent };